import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {
  FilterType,
  TableFilterDialogData,
  TableFilterDialogResultData,
  TableFilterDialogSelectionData
} from "@valg-shared/components/table/table/valg-filter-dialog/table-filter-dialog.data";
import {FormBuilder, FormGroup} from "@angular/forms";
import {EnumService} from '@valg-shared/services/enums/enum.service';
import {TableFilterDialogColumnData} from "./table-filter-dialog.data";
import {SortTableAsc} from "../../../../utils/sort-utils";
import {CheckboxOption} from "../../../input/checkbox-group/checkbox-option";

@Component({
  selector: 'valg-filter-dialog',
  templateUrl: './valg-filter-dialog.component.html'
})
export class ValgFilterDialogComponent {
  FilterType = FilterType;
  public filterFormControl: FormGroup;
  public filterDialogSelectionData: TableFilterDialogSelectionData[] = [];

  constructor(private readonly fb: FormBuilder,
              @Inject(MAT_DIALOG_DATA) public data: TableFilterDialogData,
              public dialogRef: MatDialogRef<ValgFilterDialogComponent>,
              protected enumService: EnumService ) {
    // @ts-ignore
    let columnsInOrder = data.columns.sort(function(a,b){
      return (a.column.metadata!.filter?.filterType ?? 0) - (b.column.metadata!.filter?.filterType ?? 0)
    })
    this.filterFormControl = fb.group( columnsInOrder.reduce((acc,val) => {
      return { ...acc, [val.column.title]: [ val.preSelectedOptions?.map(option => option.value) ?? (val.preSelected ?? undefined) ] }
    }, {}));

    for(const col of this.data.columns) {
      this.filterDialogSelectionData.push({
        column: col.column,
        filterType: col.column.metadata?.filter?.filterType ?? FilterType.checkbox,
        value: this.getExternalSortedOptions(col) ?? this.getSortedOptionsFromColumnData(col)
      });
    }
  }

  getExternalSortedOptions(col: TableFilterDialogColumnData) {
    const sortFunction = col.column.metadata?.filter?.filterOptionsSortFunction
    const externalOptions = col.column.metadata?.filter?.filterOptions;
    if (sortFunction && externalOptions) {
      return externalOptions.sort(sortFunction)
    }
    return externalOptions;
  }

  getSortedOptionsFromColumnData(col: TableFilterDialogColumnData) {
    const sortFunction = col.column.metadata?.filter?.filterOptionsSortFunction
    const sortedValues = sortFunction ? col.value?.sort(sortFunction) : SortTableAsc(col.value)
    return sortedValues.map((x: { toString: () => string }) => {
      return {
        label: this.enumService.translateValue(x.toString(), col.column.propKey),
        value: x,
        disabled: false } as CheckboxOption
    }) ?? [];
  }

  onFilterClicked(): void {
  let result: TableFilterDialogResultData[] = [];
  for (let col of this.filterDialogSelectionData) {
  let value = this.filterFormControl.value[col.column.title];
  
  if (value && value.length > 0){
    result.push({ column: col.column, value:value })
  }
  
  }
this.dialogRef.close({ columns: result });
  }

  onNoClick(): void {
    this.filterFormControl.reset();
  }
}
